module.exports = __webpack_public_path__ + "static/media/DOGE.b779f116.svg";